export default __webpack_public_path__ + "static/media/upload.0bff5b9a.svg";